import { Icon } from "@mui/material";
import useStyles from "./camera_styles";
import React, { useRef, useCallback, useState } from "react";
import Webcam from "react-webcam";

const CameraCapture = ({ image, setImage }) => {
  const classes = useStyles();
  const webcamRef = useRef(null);

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImage(imageSrc);
  }, [webcamRef]);

  const retake = () => {
    setImage(null);
  };

  return (
    <div className={classes.outer}>
      {!image ? (
        <Webcam
          audio={false}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          videoConstraints={{
            facingMode: "environment",
          }}
          className={classes.camera_view}
        />
      ) : (
        <img src={image} alt="captured" className={classes.image_view} />
      )}

      {image ? (
        <button className={classes.capture_button} onClick={retake}>
          <Icon fontSize="large" color="info">
            flip_camera_android
          </Icon>
        </button>
      ) : (
        <button className={classes.capture_button} onClick={capture}>
          <Icon fontSize="large" color="info">
            photo_camera
          </Icon>
        </button>
      )}
    </div>
  );
};

export default CameraCapture;
